import { observer } from 'mobx-react';
import * as React from 'react';
import styles from './Media.styl';
import { OptionalLink } from './OptionalLink';
import { PlayIcon } from './PlayIcon';
import { YoutubeThumbnail } from './YoutubeThumbnail';

@observer
export class Video extends React.Component<{ id: string, path: string }> {
    render() {
        const { path, id } = this.props;
        return (
            <OptionalLink to={`${path}/${id}`} className={styles.videoThumbnail}>
                <YoutubeThumbnail id={id} />
                <div className={styles.PlayIconContainer}>
                    <PlayIcon className={styles.PlayIcon} />
                </div>
            </OptionalLink>
        );
    }
}
